import { format as formatDate, isValid as isValidDate } from "date-fns";

/**
 * Parameter ndx values measured as Present/Not Present rather than a
 * numeric value. Mirrors WaterQualityForm.jsx's PRESENCE_ABSENCE_PARAM_IDS.
 *   29 — total coliforms
 *   30 — E. coli
 *   31 — fecal coliforms
 */
export const PRESENCE_ABSENCE_PARAM_IDS = [29, 30, 31];

export const isPaParameter = (parameterNdx) =>
  PRESENCE_ABSENCE_PARAM_IDS.includes(parameterNdx);

/**
 * Render a presence/absence result. value is expected to be 0 or 1 (or
 * null/undefined). Returns the user-facing "Present"/"Not Present" label.
 */
export const fmtPaValue = (value, { fallback = "—" } = {}) => {
  if (value === 1 || value === "1") return "Present";
  if (value === 0 || value === "0") return "Not Present";
  return fallback;
};

/**
 * Format a timestamp. Returns `fallback` for null/empty/invalid values.
 * Pattern defaults to a date-only format used by the popup; pass a longer
 * pattern for the table / records dialog.
 */
export const fmtDate = (
  value,
  { fallback = "—", pattern = "yyyy-MM-dd" } = {}
) => {
  if (!value) return fallback;
  const d = new Date(value);
  return isValidDate(d) ? formatDate(d, pattern) : fallback;
};

/**
 * Display a result value exactly as recorded. result_value is numeric in
 * the DB and arrives from the API as a string ("2.0"), preserving the
 * precision the sampler entered — trailing zeros are significant, so pass
 * strings through untouched. Plain numbers (PA 1/0, computed stats) fall
 * back to fmtNum.
 */
export const fmtResult = (value, { fallback = "—" } = {}) => {
  if (value == null || value === "") return fallback;
  if (typeof value === "string") return value;
  return fmtNum(value, { fallback });
};

/**
 * Format a numeric value with locale separators. Returns `fallback` for
 * null/empty values, the original string for non-numeric input.
 */
export const fmtNum = (
  value,
  { fallback = "—", maxFractionDigits = 4 } = {}
) => {
  if (value == null || value === "") return fallback;
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString(undefined, {
    maximumFractionDigits: maxFractionDigits,
  });
};
